import { useState } from "react";
import type { SntSelectFilter } from "@cleanup/widgets/selectors/SntSelect";
import moment from "@/constants/SensolusMoment";
import "moment-timezone";
import ItemSelector from "./ItemSelector";

// Type assertion to fix TypeScript errors with moment-timezone
const momentWithTz = moment as typeof moment & {
  tz: {
    names: () => string[];
    (timezone: string): moment.Moment;
  };
};

interface TimezoneOption {
  label: string;
  value: string;
  offset: string;
}

/**
 * The search react-select's createFilter({ ignoreAccents: false }) did: the typed
 * text, trimmed and in any case, anywhere in "label value". Written for the
 * widget's filter, which gets the option itself — createFilter expects
 * react-select's own candidate and crashed on it.
 */
const matchTimezone: SntSelectFilter = (option, searchText) =>
  `${option.label} ${option.value}`.toLowerCase().includes(searchText.trim().toLowerCase());

interface ItemTimezoneSelectorProps {
  name: string;
  [key: string]: unknown;
}

const ItemTimezoneSelector = (props: ItemTimezoneSelectorProps) => {
  const [timezones] = useState<TimezoneOption[]>(() => {
    const _citiesName = momentWithTz.tz.names();

    const cities: TimezoneOption[] = [];
    for (let i = 0; i < _citiesName.length; i++) {
      const key = _citiesName[i];

      const deprecatedList = ["EST", "MST", "HST"]; // @see TimeZone#toZoneId() in Java to compare
      if (deprecatedList.includes(key)) {
        continue;
      }

      cities.push({
        label: `(GMT ${momentWithTz.tz(key).format("Z")}) ${key}`,
        value: key,
        offset: momentWithTz.tz(key).format("Z"),
      });
    }

    cities.sort((a, b) => {
      return (
        parseInt(a.offset.replace(":", ""), 10) -
        parseInt(b.offset.replace(":", ""), 10)
      );
    });

    return cities;
  });

  return (
    <ItemSelector
      {...props}
      options={timezones}
      filterOption={matchTimezone}
    />
  );
};

export default ItemTimezoneSelector;
